import { z } from 'zod';

import { subAgentSchema } from './SubAgent';

export const subAgentListSchema = z.object({
  items: z.array(subAgentSchema),
  total: z.number(),
});

export type SubAgentListEntityApi = z.input<typeof subAgentListSchema>;

export type SubAgentListEntity = z.infer<typeof subAgentListSchema>;
